module.exports = require("punycode");


//////////////////
// WEBPACK FOOTER
// external "punycode"
// module id = 120
// module chunks = 0 1